import { ActionsUnion, createAction } from "../definitions";
import { CacheActionTypes, ICache } from "./types";

interface CacheClearActionPayload {
    cacheType: keyof ICache;
    userId: string | undefined;
}

export interface CacheAddActionPayload<T> {
    cacheType: keyof ICache;
    userId: string | undefined;
    entities: IIdDictionary<T>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CacheActions = {
    addCacheEntity: <T>(payload: CacheAddActionPayload<T>) => createAction(CacheActionTypes.ADD_CACHE_ENTITY, payload),
    clearCache: (payload: CacheClearActionPayload) => createAction(CacheActionTypes.CLEAR_CACHE, payload),
    clearAllCaches: () => createAction(CacheActionTypes.CLEAR_ALL_CACHES),
    clearAllCachesForUser: (userId: string) => createAction(CacheActionTypes.CLEAR_ALL_CACHES_FOR_USER, userId)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CacheActions = ActionsUnion<typeof CacheActions>;